// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__ddgIv","detailsBorder":"styles_detailsBorder__2amP4"};